<template>
    <div>
        <b-modal :active.sync="showModal" :id="`createcreditinvoice_${number}`" aria-modal :width="800" scroll="keep">
            <header class="modal-card-head">
                <p class="modal-card-title">Creditfactuur aanmaken</p>
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
            </header>
            <section class="modal-card-body text-left" style="border-radius:0;">
                <p v-if="message && message.length">{{ message }}</p>
                <p v-else>Welke producten wil je opnemen in de creditfactuur? Het is mogelijk om de borg of de prijs op te crediteren.</p>

                <b-table
                    :data="products"
                    :checked-rows.sync="selectedProducts"
                    checkable
                    checkbox-position="left"
                >
                    <template>
                        <b-table-column v-slot="props" field="name" label="Product" width="200">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="name" label="Aantal" width="100">
                            {{ props.row.amount || 1 }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="deposit" label="Borg" width="100" numeric>
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.deposit > 0">&euro;{{ number_format(props.row.deposit * (props.row.amount || 1)) }}</span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="price" label="Totaal" width="100" numeric>
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.price > 0">&euro;&nbsp;{{ number_format(props.row.price * (props.row.amount || 1)) }}</span>
                            <span v-else>-</span>
                        </b-table-column>
                    </template>
                </b-table>
            </section>
            <footer class="modal-card-foot">
                <b-button type="is-light" @click="showModal = false">Annuleren</b-button>
                <b-button type="is-success" @click="createCreditInvoice" :disabled="!selectedProducts.length">Maak een creditfactuur</b-button>
            </footer>
        </b-modal>

        <b-button @click="toggleModal" v-if="!hideButton && !user.deurwaarder" :outlined="hasCredits" type="is-primary">{{ hasCredits ? 'Nog een creditfactuur maken' : 'Creditfactuur aanmaken' }}</b-button>
    </div>
</template>

<script>
export default {
    name: 'CreateCreditInvoiceButton',

    props: {
        deposit_products: {
            type: Array,
            required: false,
            default: []
        },
        products: {
            type: Array,
            required: false,
            default: []
        },
        customerId: {
            type: Number|String,
            required: true
        },
        // used for a unique modal id.
        number: {
            type: String,
            required: true
        },
        hasCredits: {
            type: Boolean,
            default: false
        },
        hideTheButton: {
            type: Boolean,
            default: false
        },
        message: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            initialized: false,
            showModal: false,
            selectedProducts: [],
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },

        hideButton() {
            let hideButton = false

            if(_.has(this.user.organisation_settings, 'strictcredits') && this.user.organisation_settings.strictcredits == 1 && (this.user.role != 'pit' && !this.user.is_admin)){
                hideButton = true
            }

            return this.hideTheButton ? true : hideButton
        }
    },

    created() {
        if(_.has(this.$route, 'query.creditinvoice')){
            this.toggleModal()
        }
    },

    methods: {
        toggleModal() {
            if(!this.initialized){
                this.selectProducts()
            }

            this.showModal = !this.showModal
        },

        createCreditInvoice() {
            const query = {
                customer: this.customerId,
                invoice: _.has(this.products[0], 'invoice') ? this.products[0].invoice : _.has(this.deposit_products[0], 'invoice') ? this.deposit_products[0].invoice : null,
                products: String(_.map(this.selectedProducts, (product) => { return product.id }))
            }

            if (!query.invoice) {
                delete query.invoice
            }

            this.$router.push({name: 'CreditInvoiceRecord', query})
        },

        selectProducts() {
            // If there are products where deposit(borg) is paid for, preselect. Else select all products.
            _.each(this.products, (product, index) => {
                if(this.deposit_products.length){
                    // When passing a contract_product we use the .product to get the ID. Else we use the normal product ID.
                    const depositProduct = _.find(this.deposit_products, (depositProduct) => (depositProduct.product || depositProduct.id) == (product.product || product.id))

                    if(depositProduct){
                        product.id = depositProduct.id
                        this.selectedProducts.push(product)
                    }
                } else {
                    this.selectedProducts.push(product)
                }
            })

            this.initialized = true
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        },
    }


}
</script>